module.exports = __webpack_public_path__ + "img/line.7f7f2ef9.svg";